import React, { PropsWithChildren, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import AOS from 'aos';

import { useTranslateHook } from '@/main/hooks/translateHook';
import { AUTHORIZATION_COOKIES, getStringStorage, LASTSYNCTRANSLATIONS } from '@/main/services/storage';
import { getCultureBrowser, isNullUndefined } from '@/main/services/utils';
import { saveTranslates } from '@/main/store/translate';

import { SpinnerLoading } from '../../shared/styles';
import HomepageCookies from './cookies/homepageCookies';
import Header from './header/header';
import Footer from './footer/footer';
import * as S from './styles';

function HomepageLayout({ children }: PropsWithChildren<{}>) {
  const hasCookiesAccepted = Cookies.get(AUTHORIZATION_COOKIES);
  const dispatch = useDispatch();

  const [isCookiesAccepted, setIsCookiesAccepted] = useState(Boolean(hasCookiesAccepted))
  const translatesRedux = useSelector((state: any) => state.translate); //Notation: not removed this line (used of re-render when load translates)

  const {
    isLoadingTranslates,
    translatesLocal: translatesLocalHook,
    getTranslates
  } = useTranslateHook({
    fillTranslateLocal: false
  });

  async function loadTranslates() {
    const cultureBrowser = getCultureBrowser();
    const lastSyncTranslations = getStringStorage(
      `${LASTSYNCTRANSLATIONS}_${cultureBrowser}`
    );
    const responseApi = await getTranslates({
      culture: cultureBrowser,
      lastSyncTranslations
    });
    if (responseApi.data.result) {
      // Save translates
      dispatch(
        saveTranslates(responseApi.data.result, cultureBrowser, false, [])
      );
    }
  }
  function handleClickAllowCookies() {
    setIsCookiesAccepted(true);
    Cookies.set(AUTHORIZATION_COOKIES, 'true');
  }
  useEffect(() => {
    loadTranslates();
    AOS.init({
      duration: 600,
      offset: 150,
      easing: 'ease-in-out',
      once: true
    });
  }, []);

  if (isLoadingTranslates || isNullUndefined(translatesRedux.translates.data)) return <SpinnerLoading />;

  return (
    <S.Container>
      <Header />
      <S.Content>
        {children}
      </S.Content>
      <Footer />
      <HomepageCookies
        isCookiesAccepted={isCookiesAccepted}
        handleClickAllowCookies={handleClickAllowCookies}
      />
    </S.Container>
  )
}

export default HomepageLayout